export const EventClubType = {
    Organizer: 1,
    Association: 2
};
//# sourceMappingURL=EventClubType.js.map